import './user-profile-details-collections.scss';
import React, {useEffect, useState} from "react";
import {
    SquadflixCollection,
    SquadflixGetCollectionsResp
} from "../../myProfileView/my-profile-subroutes/my-profile-lists/types";
import {useSelector} from "react-redux";
import users from "../../../users";
import {Spinner} from "../../../shared";
import {cn} from "../../../../utils/utils";
import SquadflixCollectionCard from "../../../shared/squadflix-collection-card/squadflix-collection-card";
import {SquadDiskUserDetails} from "../user-profile-details";

import '../../myProfileView/my-profile-subroutes/my-profile-lists/my-profile-lists.scss';
import {SquadflixCollectionsApi} from "../../../../apis/squadflix-collections/SquadflixCollectionsApi";

type Props = {
    user: SquadDiskUserDetails
}

const UserProfileDetailsCollections = ({user}: Props) => {
    const [collections, setCollections] = useState<SquadflixCollection[]>([]);
    const [loading, setLoading] = useState(true);
    const darkMode = useSelector(users.selectors.isDarkMode);

    useEffect(() => {
        setCollections([]);
        setLoading(true);
        // Fetch user collections from API and set them
        SquadflixCollectionsApi.getUserPublicCollections({userId: user.uid}).then((res: SquadflixGetCollectionsResp) => {
            if (res.success) {
                setCollections(res.collections ?? []);
            }
        }).finally(() => {
            setLoading(false);
        });
    }, [user.uid]);

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{height: '20vh'}}>
            <Spinner/>
        </div>
    }

    return (<div className={cn("my-profile-lists", {"my-profile-lists--dark": darkMode})}>
        {
            collections.map((collection, i) => (
                <SquadflixCollectionCard key={collection.id + i.toString()} collection={collection}/>
            ))
        }
    </div>);
};

export default UserProfileDetailsCollections;
